// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import DataTable from "react-data-table-component";

// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import formatDate from "../../../components/utils/DateFormatter";
// import Spinner from "../../spinner/Spinner";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import ApiServices from "../../../api/ApiServices";
// import AxiosApiCall from "../../../api/AxiosApiCall";

// const TransactionHistory = () => {
//     const [transactions, setTransactions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [filterText, setFilterText] = useState("");
//     const [page, setPage] = useState(1);
//     const [perPage, setPerPage] = useState(20);
//     const [total, setTotal] = useState(0);

//     const [filters, setFilters] = useState({
//         transaction_type: "all",
//         wallet_type: "",
//         transaction_action: "",
//         start_date: "",
//         end_date: "",
//     });

//     const navigate = useNavigate();
//     const axios = AxiosApiCall();


//     const fetchTransactions = async () => {
//         setLoading(true);
//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;
//             if (!token) throw new Error("No access token found.");

//             const response = await axios.get(ApiServices.getTransactionHistory, {
//                 headers: { Authorization: `Bearer ${token}` },
//                 withCredentials: true,
//                 params: {
//                     page,
//                     per_page: perPage,
//                     search: filterText,
//                     ...filters,
//                 },
//             });

//             const { status, message, data: responseData } = response.data;
//             if (status === 200) {
//                 setTransactions(responseData.transactions || []);
//                 setTotal(responseData.total);
//                 setPage(responseData.page);
//                 setPerPage(responseData.per_page);
//             } else {
//                 handleError({ response: { status, data: { message } } }, navigate);
//             }
//         } catch (error) {
//             console.error("Error fetching transaction history:", error);
//             handleError(error, navigate);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch Transactions
//     useEffect(() => {
//         fetchTransactions();
//     }, []);

//     // Search input handler
//     const handleSearch = (e) => {
//         setFilterText(e.target.value);
//         setPage(1); // reset to first page
//     };

//     // Filters change handler
//     const handleFilterChange = (key, value) => {
//         setFilters((prev) => ({ ...prev, [key]: value }));
//         setPage(1); // reset to first page
//     };



//     // Pagination handlers
//     const handlePageChange = (newPage) => {
//         setPage(newPage);
//     };

//     const handlePerRowsChange = (newPerPage, newPage) => {
//         setPerPage(newPerPage);
//         setPage(newPage);
//     };

//     // Expandable row
//     const ExpandableComponent = ({ data }) => (
//         <div className="p-4 bg-gray-50">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                     <span className="font-semibold text-gray-700">Description:</span>
//                     <div className="text-gray-600 bg-white p-3 rounded">
//                         {data.description || "No description available"}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );

//     // Table columns
//     const columns = [
//         {
//             name: "Date",
//             selector: (row) =>
//                 row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
//             width: "200px",
//             sortable: true,
//         },
//         {
//             name: "Branch",
//             selector: (row) =>
//                 row.branch_name ? row.branch_name.toUpperCase() : "NOT AVAILABLE",
//             width: "180px",
//             sortable: true,
//         },
//         {
//             name: "Reference",
//             selector: (row) =>
//                 row.reference_number ? row.reference_number : "NOT AVAILABLE",
//             width: "180px",
//             sortable: true,
//         },
//         {
//             name: "Type",
//             selector: (row) => row.transaction_type || "NOT AVAILABLE",
//             width: "150px",
//             sortable: true,
//             cell: (row) => (
//                 <span
//                     className={`px-2 py-1 rounded text-xs font-medium ${row.transaction_type === "sale"
//                         ? "bg-blue-100 text-blue-800"
//                         : row.transaction_type === "purchase"
//                             ? "bg-orange-100 text-orange-800"
//                             : row.transaction_type === "wallet"
//                                 ? "bg-purple-100 text-purple-800"
//                                 : "bg-gray-100 text-gray-800"
//                         }`}
//                 >
//                     {row.transaction_type?.toUpperCase() || "OTHER"}
//                 </span>
//             ),
//         },
//         {
//             name: "Action",
//             selector: (row) => row.type || "NOT AVAILABLE",
//             width: "150px",
//             sortable: true,
//             cell: (row) =>
//                 row.transaction_type === "wallet" ? (
//                     <span
//                         className={`px-2 py-1 rounded text-sm font-medium ${row.type === "credit"
//                             ? "bg-darkGreen3 text-lGrey"
//                             : "bg-dash3 text-lGrey"
//                             }`}
//                     >
//                         {row.type === "credit" ? "Credit" : "Debit"}
//                     </span>
//                 ) : (
//                     <span
//                         className={`px-2 py-1 rounded text-xs font-medium ${row.type === "cash"
//                             ? "bg-green-100 text-green-800"
//                             : row.type === "credit"
//                                 ? "bg-yellow-100 text-yellow-800"
//                                 : row.type === "purchase"
//                                     ? "bg-red-100 text-red-800"
//                                     : "bg-gray-100 text-gray-800"
//                             }`}
//                     >
//                         {row.type?.toUpperCase() || "NOT AVAILABLE"}
//                     </span>
//                 ),
//         },
//         {
//             name: "Wallet",
//             selector: (row) =>
//                 row.wallet_type ? row.wallet_type?.toUpperCase() : "NOT AVAILABLE",
//             width: "150px",
//             sortable: true,
//         },
//         {
//             name: "Amount",
//             selector: (row) => row.amount || 0.0,
//             width: "150px",
//             sortable: true,
//             cell: (row) => (
//                 <span
//                     className={
//                         row.transaction_type === "wallet" && row.type === "credit"
//                             ? "text-darkGreen3"
//                             : row.transaction_type === "wallet" && row.type === "debit"
//                                 ? "text-dash3"
//                                 : row.transaction_type === "sale"
//                                     ? "text-darkGreen3"
//                                     : row.transaction_type === "purchase"
//                                         ? "text-dash3"
//                                         : "text-gray-600"
//                     }
//                 >
//                     <CurrencyFormatter value={row.amount} />
//                 </span>
//             ),
//         },
//         {
//             name: "Balance Before",
//             selector: (row) => row.balance_before || 0.0,
//             width: "150px",
//             cell: (row) =>
//                 row.balance_before ? (
//                     <CurrencyFormatter value={row.balance_before} />
//                 ) : (
//                     `₦0.00`
//                 ),
//         },
//         {
//             name: "Balance After",
//             selector: (row) => row.balance_after || 0.0,
//             width: "150px",
//             cell: (row) =>
//                 row.balance_after ? (
//                     <CurrencyFormatter value={row.balance_after} />
//                 ) : (
//                     `₦0.00`
//                 ),
//         },
//         {
//             name: "Status",
//             selector: (row) => row.status || "NOT AVAILABLE",
//             width: "130px",
//             cell: (row) => (
//                 <span
//                     className={`px-2 py-1 rounded text-xs ${row.status === "completed" || row.status === "paid"
//                         ? "bg-green-100 text-green-800"
//                         : row.status === "pending" || row.status === "unpaid"
//                             ? "bg-yellow-100 text-yellow-800"
//                             : row.status === "failed"
//                                 ? "bg-red-100 text-red-800"
//                                 : "bg-gray-100 text-gray-800"
//                         }`}
//                 >
//                     {row.status?.toUpperCase() || "UNKNOWN"}
//                 </span>
//             ),
//         },
//         {
//             name: "Party",
//             selector: (row) => row.party_name || "NOT AVAILABLE",
//             width: "150px",
//             cell: (row) => (
//                 <div>
//                     <div className="font-medium">{row.party_name || "NOT AVAILABLE"}</div>
//                     {row.party_phone && (
//                         <div className="text-xs text-gray-500">{row.party_phone}</div>
//                     )}
//                 </div>
//             ),
//         },
//     ];

//     const transactionData = transactions.map((t) => ({
//         id: t.id,
//         branch_id: t.branch_id,
//         branch_name: t.branch_name,
//         transaction_type: t.transaction_type,
//         reference_number: t.reference_number,
//         party_name: t.party_name,
//         party_phone: t.party_phone,
//         type: t.type,
//         status: t.status,
//         delivery_status: t.delivery_status,
//         amount: t.amount,
//         wallet_type: t.wallet_type,
//         source: t.source,
//         description: t.description,
//         balance_before: t.balance_before,
//         balance_after: t.balance_after,
//         created_at: t.created_at,
//     }));

//     return (
//         <MainLayouts>
//             <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//                 {/* Breadcrumb */}
//                 <section
//                     className="w-full pr-[3%] pt-3 my-3"
//                     style={{ backgroundColor: "#F7F7F7" }}
//                 >
//                     <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//                         <ol className="list-none p-0 inline-flex mb-2">
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Operations</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Transactions</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-orange1">History</p>
//                             </li>
//                         </ol>
//                     </nav>
//                 </section>

//                 {/* Search */}
//                 <div className="pb-4 bg-white flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
//                     <div className="relative lg:w-1/2">
//                         <input
//                             type="search"
//                             className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//                             placeholder="Search transactions..."
//                             value={filterText}
//                             onChange={handleSearch}
//                         />
//                     </div>
//                 </div>

//                 {/* Filters */}
//                 <div className="pb-4 bg-white grid grid-cols-1 md:grid-cols-6 gap-4 items-end">
//                     <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Transaction Type
//                         </label>
//                         <select
//                             value={filters.transaction_type}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="all">All Types</option>
//                             <option value="sales">Sales</option>
//                             <option value="purchases">Purchases</option>
//                             <option value="wallet">Wallet</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">Wallet Type</label>
//                         <select
//                             value={filters.wallet_type}
//                             onChange={(e) =>
//                                 handleFilterChange("wallet_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Wallets</option>
//                             <option value="main">Main</option>
//                             <option value="incentive">Incentive</option>
//                             <option value="expense">Expense</option>
//                             <option value="float">Float</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Transaction Action
//                         </label>
//                         <select
//                             value={filters.transaction_action}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_action", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Actions</option>
//                             <option value="credit">Credit</option>
//                             <option value="debit">Debit</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">Start Date</label>
//                         <input
//                             type="date"
//                             value={filters.start_date}
//                             onChange={(e) =>
//                                 handleFilterChange("start_date", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">End Date</label>
//                         <input
//                             type="date"
//                             value={filters.end_date}
//                             onChange={(e) => handleFilterChange("end_date", e.target.value)}
//                             className="w-full border p-2 rounded"
//                         />
//                     </div>

//                     <div>
//                         <button
//                             onClick={fetchTransactions}
//                             className="w-full bg-darkGreen3 text-lGrey p-2 rounded hover:bg-blue-700"
//                         >
//                             Apply Filters
//                         </button>
//                     </div>
//                 </div>

//                 {/* Data Table */}
//                 {loading ? (
//                     <Spinner />
//                 ) : (
//                     <DataTable
//                         columns={columns}
//                         data={transactionData}
//                         pagination
//                         paginationServer
//                         paginationTotalRows={total}
//                         paginationDefaultPage={page}
//                         paginationPerPage={perPage}
//                         onChangePage={handlePageChange}
//                         onChangeRowsPerPage={handlePerRowsChange}
//                         highlightOnHover
//                         striped
//                         customStyles={CustomStyles}
//                         noDataComponent={
//                             <div className="text-center py-4">
//                                 <p>No transaction history found</p>
//                                 {filterText && (
//                                     <p className="text-sm text-gray-500">
//                                         Try adjusting your search or filters
//                                     </p>
//                                 )}
//                             </div>
//                         }
//                         expandableRows
//                         expandableRowsComponent={ExpandableComponent}
//                     />
//                 )}
//             </div>
//         </MainLayouts>
//     );
// };

// export default TransactionHistory;

// import { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import DataTable from "react-data-table-component";

// import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import formatDate from "../../../components/utils/DateFormatter";
// import Spinner from "../../spinner/Spinner";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import ApiServices from "../../../api/ApiServices";
// import AxiosApiCall from "../../../api/AxiosApiCall";

// const TransactionHistory = () => {
//     const [transactions, setTransactions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [loadingForm, setLoadingForm] = useState(false);
//     const [filterText, setFilterText] = useState("");
//     const [page, setPage] = useState(1);
//     const [perPage, setPerPage] = useState(20);
//     const [total, setTotal] = useState(0);

//     const [filters, setFilters] = useState({
//         transaction_type: "all",
//         wallet_type: "",
//         transaction_action: "",
//         start_date: "",
//         end_date: "",
//     });

//     const navigate = useNavigate();
//     const axios = AxiosApiCall();

//     const fetchTransactions = async () => {
//         setLoading(true);
//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;
//             if (!token) throw new Error("No access token found.");

//             const response = await axios.get(ApiServices.getTransactionHistory, {
//                 headers: { Authorization: `Bearer ${token}` },
//                 withCredentials: true,
//                 params: {
//                     page,
//                     per_page: perPage,
//                     search: filterText || undefined,
//                     transaction_type: filters.transaction_type,
//                     wallet_type: filters.wallet_type || undefined,
//                     transaction_action: filters.transaction_action || undefined,
//                     start_date: filters.start_date || undefined,
//                     end_date: filters.end_date || undefined,
//                     sort_order: "desc",

//                 },
//             });

//             const { status, message, data: responseData } = response.data;
//             if (status === 200) {
//                 setTransactions(responseData.transactions || []);
//                 setTotal(responseData.total);
//                 setPage(responseData.page);
//                 setPerPage(responseData.per_page);
//             } else {
//                 handleError({ response: { status, data: { message } } }, navigate);
//             }
//         } catch (error) {
//             console.error("Error fetching transaction history:", error);
//             handleError(error, navigate);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Initial fetch
//     useEffect(() => {
//         fetchTransactions();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     // Search input handler
//     const handleSearch = (e) => {
//         setFilterText(e.target.value);
//         setPage(1);
//     };

//     // Filters change handler
//     const handleFilterChange = (key, value) => {
//         setFilters((prev) => ({ ...prev, [key]: value }));
//         setPage(1);
//     };

//     // Pagination handlers
//     const handlePageChange = (newPage) => {
//         setPage(newPage);
//     };

//     const handlePerRowsChange = (newPerPage, newPage) => {
//         setPerPage(newPerPage);
//         setPage(newPage);
//     };

//     // Expandable row
//     const ExpandableComponent = ({ data }) => (
//         <div className="p-4 bg-gray-50 grid gap-3">
//             <p>
//                 <span className="font-semibold">Description:</span>{" "}
//                 {data.description || "No description available"}
//             </p>
//         </div>
//     );


//     const columns = useMemo(
//         () => [
//             {
//                 name: "Date",
//                 selector: (row) =>
//                     row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
//                 width: "200px",
//                 sortable: true,
//             },
//             {
//                 name: "Branch",
//                 selector: (row) =>
//                     row.branch_name ? row.branch_name.toUpperCase() : "NOT AVAILABLE",
//                 width: "180px",
//                 sortable: true,
//             },
//             {
//                 name: "Reference",
//                 selector: (row) =>
//                     row.reference_number ? row.reference_number : "NOT AVAILABLE",
//                 width: "180px",
//                 sortable: true,
//             },
//             {
//                 name: "Type",
//                 selector: (row) => row.transaction_type || "NOT AVAILABLE",
//                 width: "150px",
//                 sortable: true,
//                 cell: (row) => (
//                     <span
//                         className={`px-2 py-1 rounded text-xs font-medium ${row.transaction_type === "sales"
//                             ? "bg-blue-100 text-blue-800"
//                             : row.transaction_type === "purchases"
//                                 ? "bg-orange-100 text-orange-800"
//                                 : row.transaction_type === "wallet"
//                                     ? "bg-purple-100 text-purple-800"
//                                     : "bg-gray-100 text-gray-800"
//                             }`}
//                     >
//                         {row.transaction_type?.toUpperCase() || "OTHER"}
//                     </span>
//                 ),
//             },
//             {
//                 name: "Action",
//                 selector: (row) => row.type || "NOT AVAILABLE",
//                 width: "150px",
//                 sortable: true,
//                 cell: (row) =>
//                     row.transaction_type === "wallet" ? (
//                         <span
//                             className={`px-2 py-1 rounded text-sm font-medium ${row.type === "credit"
//                                 ? "bg-darkGreen3 text-lGrey"
//                                 : "bg-dash3 text-lGrey"
//                                 }`}
//                         >
//                             {row.type === "credit" ? "Credit" : "Debit"}
//                         </span>
//                     ) : (
//                         <span
//                             className={`px-2 py-1 rounded text-xs font-medium ${row.type === "cash"
//                                 ? "bg-green-100 text-green-800"
//                                 : row.type === "credit"
//                                     ? "bg-yellow-100 text-yellow-800"
//                                     : row.type === "purchase"
//                                         ? "bg-red-100 text-red-800"
//                                         : "bg-gray-100 text-gray-800"
//                                 }`}
//                         >
//                             {row.type?.toUpperCase() || "NOT AVAILABLE"}
//                         </span>
//                     ),
//             },
//             {
//                 name: "Wallet",
//                 selector: (row) =>
//                     row.wallet_type ? row.wallet_type?.toUpperCase() : "NOT AVAILABLE",
//                 width: "150px",
//                 sortable: true,
//             },
//             {
//                 name: "Amount",
//                 selector: (row) => row.amount || 0.0,
//                 width: "150px",
//                 sortable: true,
//                 cell: (row) => (
//                     <span
//                         className={
//                             row.transaction_type === "wallet" && row.type === "credit"
//                                 ? "text-darkGreen3"
//                                 : row.transaction_type === "wallet" && row.type === "debit"
//                                     ? "text-dash3"
//                                     : row.transaction_type === "sales"
//                                         ? "text-darkGreen3"
//                                         : row.transaction_type === "purchases"
//                                             ? "text-dash3"
//                                             : "text-gray-600"
//                         }
//                     >
//                         <CurrencyFormatter value={row.amount} />
//                     </span>
//                 ),
//             },
//             {
//                 name: "Balance Before",
//                 selector: (row) => row.balance_before || 0.0,
//                 width: "150px",
//                 cell: (row) =>
//                     row.balance_before ? (
//                         <CurrencyFormatter value={row.balance_before} />
//                     ) : (
//                         `₦0.00`
//                     ),
//             },
//             {
//                 name: "Balance After",
//                 selector: (row) => row.balance_after || 0.0,
//                 width: "150px",
//                 cell: (row) =>
//                     row.balance_after ? (
//                         <CurrencyFormatter value={row.balance_after} />
//                     ) : (
//                         `₦0.00`
//                     ),
//             },
//             {
//                 name: "Status",
//                 selector: (row) => row.status || "NOT AVAILABLE",
//                 width: "130px",
//                 cell: (row) => (
//                     <span
//                         className={`px-2 py-1 rounded text-xs ${row.status === "completed" || row.status === "paid"
//                             ? "bg-green-100 text-green-800"
//                             : row.status === "pending" || row.status === "unpaid"
//                                 ? "bg-yellow-100 text-yellow-800"
//                                 : row.status === "failed"
//                                     ? "bg-red-100 text-red-800"
//                                     : "bg-gray-100 text-gray-800"
//                             }`}
//                     >
//                         {row.status?.toUpperCase() || "UNKNOWN"}
//                     </span>
//                 ),
//             },
//             {
//                 name: "Party",
//                 selector: (row) => row.party_name || "NOT AVAILABLE",
//                 width: "150px",
//                 cell: (row) => (
//                     <div>
//                         <div className="font-medium">{row.party_name || "NOT AVAILABLE"}</div>
//                         {row.party_phone && (
//                             <div className="text-xs text-gray-500">{row.party_phone}</div>
//                         )}
//                     </div>
//                 ),
//             },
//         ],
//         []
//     );

//     return (
//         <MainLayouts>
//             <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//                 {/* Breadcrumb */}
//                 <section
//                     className="w-full pr-[3%] pt-3 my-3"
//                     style={{ backgroundColor: "#F7F7F7" }}
//                 >
//                     <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//                         <ol className="list-none p-0 inline-flex mb-2">
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Operations</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Transactions</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-orange1">History</p>
//                             </li>
//                         </ol>
//                     </nav>
//                 </section>

//                 {/* Search */}
//                 {/* <div className="pb-4 bg-white flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
//                     <div className="relative lg:w-1/2">
//                         <input
//                             type="search"
//                             className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//                             placeholder="Search transactions..."
//                             value={filterText}
//                             onChange={handleSearch}
//                         />
//                     </div>
//                 </div> */}

//                 {/* Filters */}
//                 <div className="pb-4 bg-white grid grid-cols-1 md:grid-cols-6 gap-4 items-end">
//                     <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Transaction Type
//                         </label>
//                         <select
//                             value={filters.transaction_type}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="all">All Types</option>
//                             <option value="sales">Sales</option>
//                             <option value="purchases">Purchases</option>
//                             <option value="wallet">Wallet</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">Wallet Type</label>
//                         <select
//                             value={filters.wallet_type}
//                             onChange={(e) =>
//                                 handleFilterChange("wallet_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Wallets</option>
//                             <option value="main">Main</option>
//                             <option value="incentive">Incentive</option>
//                             <option value="expense">Expense</option>
//                             <option value="float">Float</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Transaction Action
//                         </label>
//                         <select
//                             value={filters.transaction_action}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_action", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Actions</option>
//                             <option value="credit">Credit</option>
//                             <option value="debit">Debit</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">Start Date</label>
//                         <input
//                             type="date"
//                             value={filters.start_date}
//                             onChange={(e) =>
//                                 handleFilterChange("start_date", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         />
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">End Date</label>
//                         <input
//                             type="date"
//                             value={filters.end_date}
//                             onChange={(e) =>
//                                 handleFilterChange("end_date", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                             min={filters.start_date || undefined}
//                         />
//                     </div>

//                     {/* <div>
//                         <button
//                             onClick={fetchTransactions}
//                             className="w-full bg-darkGreen3 text-lGrey p-2 rounded hover:bg-blue-700"
//                         >
//                             Apply Filters
//                         </button>
//                     </div> */}
//                 </div>

//                 {/* Filters */}
//                 <div className="pb-4 bg-white grid grid-cols-1 md:grid-cols-6 gap-4 items-end">
//                     {/* <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Sort By
//                         </label>
//                         <select
//                             value={filters.transaction_type}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="all">All Types</option>
//                             <option value="sales">Sales</option>
//                             <option value="purchases">Purchases</option>
//                             <option value="wallet">Wallet</option>
//                         </select>
//                     </div> */}

//                     {/* <div>
//                         <label className="block text-sm font-medium mb-1">Sort Order</label>
//                         <select
//                             value={filters.wallet_type}
//                             onChange={(e) =>
//                                 handleFilterChange("wallet_type", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Wallets</option>
//                             <option value="main">Main</option>
//                             <option value="incentive">Incentive</option>
//                             <option value="expense">Expense</option>
//                             <option value="float">Float</option>
//                         </select>
//                     </div> */}

//                     <div>
//                         <label className="block text-sm font-medium mb-1">
//                             Branch Office
//                         </label>
//                         <select
//                             value={filters.transaction_action}
//                             onChange={(e) =>
//                                 handleFilterChange("transaction_action", e.target.value)
//                             }
//                             className="w-full border p-2 rounded"
//                         >
//                             <option value="">All Actions</option>
//                             <option value="credit">Credit</option>
//                             <option value="debit">Debit</option>
//                         </select>
//                     </div>

//                     <div>
//                         <label className="block text-sm font-medium mb-1">Search</label>
//                         <input
//                             type="search"
//                             className="block w-full  md:w-100px px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//                             placeholder="Search transactions..."
//                             value={filterText}
//                             onChange={handleSearch}
//                         />
//                     </div>

//                     <div>
//                         <button
//                             onClick={fetchTransactions}
//                             className="w-full bg-darkGreen3 text-lGrey p-2 rounded hover:bg-blue-700"
//                         >
//                             Apply Filters
//                         </button>
//                     </div>
//                 </div>

//                 {/* Data Table */}
//                 {loading ? (
//                     <Spinner />
//                 ) : (
//                     <DataTable
//                         columns={columns}
//                         data={transactions}
//                         pagination
//                         paginationServer
//                         paginationTotalRows={total}
//                         paginationDefaultPage={page}
//                         paginationPerPage={perPage}
//                         onChangePage={handlePageChange}
//                         onChangeRowsPerPage={handlePerRowsChange}
//                         highlightOnHover
//                         striped
//                         customStyles={CustomStyles}
//                         noDataComponent={
//                             <div className="text-center py-4">
//                                 <p>No transaction history found</p>
//                                 {filterText && (
//                                     <p className="text-sm text-gray-500">
//                                         Try adjusting your search or filters
//                                     </p>
//                                 )}
//                             </div>
//                         }
//                         expandableRows
//                         expandableRowsComponent={ExpandableComponent}
//                     />
//                 )}
//             </div>
//         </MainLayouts>
//     );
// };

// export default TransactionHistory;


import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import formatDate from "../../../components/utils/DateFormatter";
import Spinner from "../../spinner/Spinner";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import ApiServices from "../../../api/ApiServices";
import AxiosApiCall from "../../../api/AxiosApiCall";

const TransactionHistory = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [total, setTotal] = useState(0);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const [filters, setFilters] = useState({
        transaction_type: "all",
        wallet_type: "",
        transaction_action: "",
        start_date: "",
        end_date: "",
    });

    const navigate = useNavigate();
    const axios = AxiosApiCall();

    const fetchTransactions = async () => {
        setLoading(true);
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) throw new Error("No access token found.");

            const response = await axios.get(ApiServices.getTransactionHistory, {
                headers: { Authorization: `Bearer ${token}` },
                withCredentials: true,
                params: {
                    page,
                    per_page: perPage,
                    search: filterText || undefined,
                    transaction_type: filters.transaction_type !== "all" ? filters.transaction_type : undefined,
                    wallet_type: filters.wallet_type || undefined,
                    transaction_action: filters.transaction_action || undefined,
                    start_date: filters.start_date || undefined,
                    end_date: filters.end_date || undefined,
                    sort_order: "desc",
                },
            });

            const { status, message, data: responseData } = response.data;
            if (status === 200) {
                setTransactions(responseData.transactions || []);
                setTotal(responseData.total);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            console.error("Error fetching transaction history:", error);
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetch
    useEffect(() => {
        fetchTransactions();
    }, []);

    // Fetch on pagination change
    useEffect(() => {
        if (page > 1 || perPage !== 20) {
            fetchTransactions();
        }
    }, [page, perPage]);

    // Handle search input
    const handleFilter = (e) => {
        setFilterText(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle);
        setPage(1);
    };

    // Handle filter changes
    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
    };

    // Apply filters
    const handleApplyFilters = () => {
        setPage(1);
        fetchTransactions();
    };

    // Clear all filters
    const handleClearFilters = () => {
        setFilters({
            transaction_type: "all",
            wallet_type: "",
            transaction_action: "",
            start_date: "",
            end_date: "",
        });
        setFilterText("");
        setPage(1);
        // Fetch will trigger automatically after state updates
        setTimeout(() => fetchTransactions(), 0);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage, newPage) => {
        setPerPage(newPerPage);
        setPage(newPage);
    };

    const ExpandableComponent = ({ data }) => (
        <div className="p-4 bg-gray-50">
            <p>
                <span className="font-semibold">Description:</span>{" "}
                {data.description || "No description available"}
            </p>
        </div>
    );

    const columns = useMemo(
        () => [
            {
                name: "Date",
                selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
                width: "200px",
                sortable: true,
            },
            {
                name: "Branch",
                selector: (row) => row.branch_name ? row.branch_name.toUpperCase() : "NOT AVAILABLE",
                width: "180px",
                sortable: true,
            },
            {
                name: "Reference",
                selector: (row) => row.reference_number || "NOT AVAILABLE",
                width: "180px",
                sortable: true,
            },
            {
                name: "Type",
                selector: (row) => row.transaction_type || "NOT AVAILABLE",
                width: "150px",
                sortable: true,
                cell: (row) => (
                    <span
                        className={`px-2 py-1 rounded text-xs font-medium ${row.transaction_type === "sales"
                            ? "bg-blue-100 text-blue-800"
                            : row.transaction_type === "purchases"
                                ? "bg-orange-100 text-orange-800"
                                : row.transaction_type === "wallet"
                                    ? "bg-purple-100 text-purple-800"
                                    : "bg-gray-100 text-gray-800"
                            }`}
                    >
                        {row.transaction_type?.toUpperCase() || "OTHER"}
                    </span>
                ),
            },
            {
                name: "Action",
                selector: (row) => row.type || "NOT AVAILABLE",
                width: "150px",
                sortable: true,
                cell: (row) =>
                    row.transaction_type === "wallet" ? (
                        <span
                            className={`px-2 py-1 rounded text-sm font-medium ${row.type === "credit" ? "bg-darkGreen3 text-lGrey" : "bg-dash3 text-lGrey"
                                }`}
                        >
                            {row.type === "credit" ? "Credit" : "Debit"}
                        </span>
                    ) : (
                        <span
                            className={`px-2 py-1 rounded text-xs font-medium ${row.type === "cash"
                                ? "bg-green-100 text-green-800"
                                : row.type === "credit"
                                    ? "bg-orange1 text-lGrey"
                                    : row.type === "purchase"
                                        ? "bg-darkGreen3 text-lGrey"
                                        : "bg-dash5 text-lGrey"
                                }`}
                        >
                            {row.type?.toUpperCase() || "NOT AVAILABLE"}
                        </span>
                    ),
            },
            {
                name: "Wallet",
                selector: (row) => row.wallet_type?.toUpperCase() || "NOT AVAILABLE",
                width: "150px",
                sortable: true,
            },
            {
                name: "Amount",
                selector: (row) => row.amount || 0.0,
                width: "150px",
                sortable: true,
                cell: (row) => (
                    <span
                        className={
                            row.transaction_type === "wallet" && row.type === "credit"
                                ? "text-darkGreen3"
                                : row.transaction_type === "wallet" && row.type === "debit"
                                    ? "text-dash3"
                                    : row.transaction_type === "sales"
                                        ? "text-darkGreen3"
                                        : row.transaction_type === "purchases"
                                            ? "text-dash3"
                                            : "text-gray-600"
                        }
                    >
                        <CurrencyFormatter value={row.amount} />
                    </span>
                ),
            },
            {
                name: "Balance Before",
                selector: (row) => row.balance_before || 0.0,
                width: "150px",
                cell: (row) =>
                    row.balance_before ? <CurrencyFormatter value={row.balance_before} /> : `₦0.00`,
            },
            {
                name: "Balance After",
                selector: (row) => row.balance_after || 0.0,
                width: "150px",
                cell: (row) =>
                    row.balance_after ? <CurrencyFormatter value={row.balance_after} /> : `₦0.00`,
            },
            {
                name: "Status",
                selector: (row) => row.status || "NOT AVAILABLE",
                width: "130px",
                cell: (row) => (
                    <span
                        className={`px-2 py-1 rounded text-xs ${row.status === "completed" || row.status === "paid"
                            ? "bg-green-100 text-green-800"
                            : row.status === "pending" || row.status === "unpaid"
                                ? "bg-yellow-100 text-yellow-800"
                                : row.status === "failed"
                                    ? "bg-red-100 text-red-800"
                                    : "bg-gray-100 text-gray-800"
                            }`}
                    >
                        {row.status?.toUpperCase() || "UNKNOWN"}
                    </span>
                ),
            },
            // {
            //     name: "Source",
            //     selector: (row) => row.party_name || "NOT AVAILABLE",
            //     width: "150px",
            //     cell: (row) => (
            //         <div>
            //             <div className="font-medium">{row.party_name || "NOT AVAILABLE"}</div>
            //             {row.party_phone && <div className="text-xs text-gray-500">{row.party_phone}</div>}
            //         </div>
            //     ),
            // },
            {
                name: "Source",
                sortable: true,
                width: "200px",
                cell: (row) => (
                    <div>
                        <span className="block font-bold">
                            {row.party_name
                                ? row.party_name
                                : "NOT AVAILABLE"}
                        </span>
                        <span className="block font-bold">
                            {row.party_phone
                                ? row.party_phone
                                : "NOT AVAILABLE"}
                        </span>
                        <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
                            {row.type
                                ? row.type.toLowerCase()
                                : "NOT AVAILABLE"}
                        </span>
                    </div>
                ),
            },
            // {
            //     name: "Source",
            //     selector: (row) => row.party_name || "NOT AVAILABLE",
            //     width: "150px",
            //     cell: (row) => {
            //         let label = "Source";

            //         // Normalize type to lowercase
            //         const nameType = row.type ? row.type.toLowerCase() : "";

            //         if (nameType === "purchase") {
            //             label = "Supplier";
            //         } else if (type === "customer") {
            //             label = "Sales";
            //         }

            //         return (
            //             <div>
            //                 {/* Display the PARTY NAME */}
            //                 <div className="font-medium">
            //                     {row.party_name || "NOT AVAILABLE"}
            //                 </div>

            //                 {/* Display the TYPE LABEL as badge */}
            //                 <div className="mt-1">
            //                     <span
            //                         className={`text-xs font-semibold px-2 py-0.5 rounded-full ${type === "purchase"
            //                             ? "bg-green-100 text-green-700"
            //                             : type === "customer"
            //                                 ? "bg-dash5 text-white"
            //                                 : "bg-darkGreen3 text-white"
            //                             }`}
            //                     >
            //                         {nameType}
            //                     </span>
            //                 </div>

            //                 {/* Display PHONE if available */}
            //                 {row.party_phone && (
            //                     <div className="text-xs text-gray-400 mt-1">
            //                         {row.party_phone}
            //                     </div>
            //                 )}
            //             </div>
            //         );
            //     },
            // }
        ],
        []
    );

    // Filter transactions client-side based on search text
    const filteredTransactions = useMemo(() => {
        if (!filterText) return transactions;

        return transactions.filter((item) =>
            Object.values(item).some(
                (value) =>
                    typeof value === "string" &&
                    value.toLowerCase().includes(filterText.toLowerCase())
            )
        );
    }, [transactions, filterText]);

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                {/* Breadcrumb */}
                <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-darkGreen3 pr-2">Operations</p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-darkGreen3 pr-2">Transactions</p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">History</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                {/* Search and Filters Section */}
                <div className="pb-4 bg-white flex flex-wrap items-center justify-between gap-4 mb-4">
                    {/* Search Input */}
                    <div className="relative w-full md:w-auto flex-grow">
                        <input
                            type="search"
                            className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                            placeholder="Search by reference, party, branch..."
                            value={filterText}
                            onChange={handleFilter}
                        />
                    </div>
                </div>

                {/* Filter Controls - Row 1 */}
                <div className="pb-4 bg-white grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
                    <div>
                        <label className="block text-sm font-medium mb-1">Transaction Type</label>
                        <select
                            value={filters.transaction_type}
                            onChange={(e) => handleFilterChange("transaction_type", e.target.value)}
                            className="w-full border border-gray-300 p-2 rounded-lg bg-gray-50"
                        >
                            <option value="all">All Types</option>
                            <option value="sales">Sales</option>
                            <option value="purchases">Purchases</option>
                            <option value="wallet">Wallet</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Wallet Type</label>
                        <select
                            value={filters.wallet_type}
                            onChange={(e) => handleFilterChange("wallet_type", e.target.value)}
                            className="w-full border border-gray-300 p-2 rounded-lg bg-gray-50"
                        >
                            <option value="">All Wallets</option>
                            <option value="main">Main</option>
                            <option value="incentive">Incentive</option>
                            <option value="expense">Expense</option>
                            <option value="float">Float</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Transaction Action</label>
                        <select
                            value={filters.transaction_action}
                            onChange={(e) => handleFilterChange("transaction_action", e.target.value)}
                            className="w-full border border-gray-300 p-2 rounded-lg bg-gray-50"
                        >
                            <option value="">All Actions</option>
                            <option value="credit">Credit</option>
                            <option value="debit">Debit</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">Start Date</label>
                        <input
                            type="date"
                            value={filters.start_date}
                            onChange={(e) => handleFilterChange("start_date", e.target.value)}
                            className="w-full border border-gray-300 p-2 rounded-lg bg-gray-50"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium mb-1">End Date</label>
                        <input
                            type="date"
                            value={filters.end_date}
                            onChange={(e) => handleFilterChange("end_date", e.target.value)}
                            className="w-full border border-gray-300 p-2 rounded-lg bg-gray-50"
                            min={filters.start_date || undefined}
                        />
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="pb-4 bg-white flex gap-2">
                    <button
                        onClick={handleApplyFilters}
                        className="px-6 py-2 bg-darkGreen3 text-lGrey rounded-lg hover:bg-green-700 transition"
                    >
                        Apply Filters
                    </button>
                    <button
                        onClick={handleClearFilters}
                        className="px-6 py-2 bg-orange1 text-lGrey rounded-lg hover:bg-gray-600 transition"
                    >
                        Clear Filters
                    </button>
                </div>

                {/* Data Table */}
                {loading ? (
                    <Spinner loading={loading} />
                ) : (
                    <DataTable
                        columns={columns}
                        data={filteredTransactions}
                        pagination
                        paginationServer
                        paginationTotalRows={total}
                        paginationDefaultPage={page}
                        paginationPerPage={perPage}
                        paginationResetDefaultPage={resetPaginationToggle}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        highlightOnHover
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={
                            <div className="text-center py-4">
                                <p>No transaction history found</p>
                                {filterText && (
                                    <p className="text-sm text-gray-500">
                                        Try adjusting your search or filters
                                    </p>
                                )}
                            </div>
                        }
                        expandableRows
                        expandableRowsComponent={ExpandableComponent}
                    />
                )}
            </div>
        </MainLayouts>
    );
};

export default TransactionHistory;

